import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function parsePermissionsJson(value) {
  if (!value || typeof value !== 'string') return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export async function fetchSecretaryUsers() {
  const res = await fetch(`${API_BASE}/api/secretary/users`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المستخدمين'));
  const list = Array.isArray(data) ? data : [];
  return list.map((u) => ({
    id: u.id,
    userName: u.userName,
    fullName: u.fullName ?? '',
    email: u.email ?? '',
    phone: u.phone ?? '',
    isActive: !!u.isActive,
    departmentId: u.departmentId != null ? String(u.departmentId) : '',
    departmentName: u.departmentName ?? '',
    permissions: parsePermissionsJson(u.permissionsJson),
    permissionsJson: u.permissionsJson ?? '{}',
  }));
}

export async function createSecretaryUser(payload) {
  const res = await fetch(`${API_BASE}/api/secretary/users`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة المستخدم'));
  return {
    id: data.id,
    userName: data.userName,
    fullName: data.fullName ?? '',
    email: data.email ?? '',
    phone: data.phone ?? '',
    isActive: !!data.isActive,
    departmentId: data.departmentId != null ? String(data.departmentId) : '',
    departmentName: data.departmentName ?? '',
    permissions: parsePermissionsJson(data.permissionsJson),
    permissionsJson: data.permissionsJson ?? '{}',
  };
}

export async function updateSecretaryUser(userId, payload) {
  const res = await fetch(`${API_BASE}/api/secretary/users/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث المستخدم'));
  return {
    id: data.id,
    userName: data.userName,
    fullName: data.fullName ?? '',
    email: data.email ?? '',
    phone: data.phone ?? '',
    isActive: !!data.isActive,
    departmentId: data.departmentId != null ? String(data.departmentId) : '',
    departmentName: data.departmentName ?? '',
    permissions: parsePermissionsJson(data.permissionsJson),
    permissionsJson: data.permissionsJson ?? '{}',
  };
}

export async function updateSecretaryUserPermissions(userId, permissions) {
  const permissionsJson = JSON.stringify(permissions ?? {});
  const res = await fetch(`${API_BASE}/api/secretary/users/${encodeURIComponent(userId)}/permissions`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify({ permissionsJson }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ الصلاحيات'));
  return data;
}

export async function deleteSecretaryUser(userId) {
  const res = await fetch(`${API_BASE}/api/secretary/users/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حذف أمين السر'));
  return data;
}
